module.exports = __webpack_public_path__ + "img/报告厅亮.6d2badd0.png";